export default __webpack_public_path__ + "static/media/the factory.91a68313.jpg";